import { ASSETS_PATH_BASE } from './../config/index'

export function complementAssetUrl<T extends string | (string | undefined)>(url: T) {
  if (!url || url.startsWith('http')) {
    return url
  }
  return ASSETS_PATH_BASE + url
}
